/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const getpledgeDummyData = () => {
    return {
        body: {
            BeneficiaryID: "1208250036335193",
            Data: [
                {
                    Category: "C",
                    DPQty: 103,
                    HairCut: 0.7,
                    ISINCode: "INE669E01016",
                    PledgeQty: 4,
                    PledgeValue: 601.8084,
                    Qty: 111,
                    Rate: 7.9,
                    ScripName: "IDEA",
                },
                {
                    Category: "C",
                    DPQty: 12,
                    HairCut: 0.7,
                    ISINCode: "INE565A01014",
                    PledgeQty: 0,
                    PledgeValue: 226.4292,
                    Qty: 12,
                    Rate: 24.55,
                    ScripName: "IOB",
                },
                {
                    Category: "C",
                    DPQty: 2,
                    HairCut: 0.7,
                    ISINCode: "INE220G01021",
                    PledgeQty: 0,
                    PledgeValue: 0,
                    Qty: 2,
                    Rate: 331.75,
                    ScripName: "JSL",
                },
                {
                    Category: "B",
                    DPQty: 12,
                    HairCut: 0.78,
                    ISINCode: "INE528G01035",
                    PledgeQty: 1,
                    PledgeValue: 150.9708,
                    Qty: 14,
                    Rate: 16.2,
                    ScripName: "YESBANK",
                },
            ],
            Message: "Success",
            Status: 0,
        },
        head: {
            responseCode: "5PGPRequest",
            status: "0",
            statusDescription: "Success",
        },
    };
};
